
<template>
    <div class="pa-5">
        <div class="mb-5 d-flex align-justify">
            <h3>Approved Posts for {{ details.event_code }}</h3>
        </div>
        <div class="mb-5 d-flex align-justify">
            <v-text-field outlined dense hide-details label="Search" v-model="search1"></v-text-field>
            <v-spacer></v-spacer>
            <v-btn small text color="success" @click="exportRecords()"><v-icon>mdi-download</v-icon> export</v-btn>
            <v-btn small text @click="showPrintDialog()" color="primary">  <v-icon>mdi-printer</v-icon> Print</v-btn>
        </div>
        <v-data-table
            :headers="headers"
            :items="testimonials"
            :search="search1"
            class="elevation-1"
            >
            <template v-slot:body = {items}>
                <tbody>
                    <tr
                        v-for="item in items"
                        :key="item.id"
                    >
                        <td>{{ item.name }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.mobile_no }}</td>
                        <td>{{ item.company }}</td>
                        <td>{{ item.position }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>
                            <v-btn x-small :color="item.visible == 1 ? 'primary' : 'error'">
                                {{ item.visible == 1 ? 'Yes' : 'No' }}
                            </v-btn>
                        </td>
                        <td>
                            <v-btn x-small  color="primary" @click="viewPostDetails(item)">
                                View Details
                            </v-btn>
                        </td>
                        <td>
                            <v-btn x-small icon @click="viewQRCode(item.qr_code)">
                                <v-icon>mdi-qrcode-scan</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
        <v-dialog v-model="post_dialog" width="500">
            <testimonial-details-dialog :post="post" @refreshList="refresh(); post_dialog = false;"></testimonial-details-dialog>
        </v-dialog>
        <v-dialog v-model="qr_code_dialog" width="350">
            <qr-code-dialog :qr_code="qr_code"></qr-code-dialog>
        </v-dialog>
        <v-dialog max-width="1500" v-model="printDialog">
            <v-card rounded="0">
                <v-card-title>
                    <span>{{ details.event_code }}</span>
                    <v-spacer></v-spacer>
                    <span>
                        <v-btn small text 
                            :color="canvasOrientation=='portrait' ? 'primary' : 'default'" 
                            @click="setCanvasOrientation('portrait')">Portrait</v-btn>
                        <v-btn small text 
                            :color="canvasOrientation!='portrait' ? 'primary' : 'default'" 
                            @click="setCanvasOrientation('landscape')">Landscape</v-btn>
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters>
                    <v-col cols="12" md="4" sm="5" style="height: calc(100vh - 250px); overflow-y: auto;">
                        <div class="pa-5">
                            <v-text-field label="Search" v-model="search" dense hide-details class="mb-3"></v-text-field>
                            <div class="d-flex flex-row flex-wrap">
                                <template v-for="post in filteredPosts">
                                    <v-img 
                                        class="image mr-2 mb-2"
                                        :class="selectedImages.includes(post.id) ? 'selected' : ''"
                                        @click="selectImage(post)"
                                        max-width="100"
                                        :src="`${baseUrl}/uploads/posts/images/${post.id}/${post.image}`" width="100" height="120" v-if="post.image"/>
                                </template>
                            </div>
                        </div>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12" md="8" sm="7">
                         <div class="pa-3" @keydown="onKeydown" tabindex="0">
                            <div>
                                <v-btn text x-small @click="bringToFront()"><v-icon>mdi-flip-to-front</v-icon> Bring to Front</v-btn>
                                <v-btn text x-small @click="sendToBack()"><v-icon>mdi-flip-to-front</v-icon>Send To Back</v-btn>
                                <v-btn text x-small @click="removeSelected()"><v-icon>mdi-close</v-icon>Delete</v-btn>
                            </div>
                            <canvas ref="canvas" width="750" height="500" style="border:1px solid grey;"></canvas>
                         </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <div class="pa-2">
                        <template v-for="frame in subscription.frames">
                            <!-- <v-img max-width="40" :src="`${baseUrl}/uploads/subscriptions/${subscription.id}/frames/${frame.frame_image}`"></v-img> -->
                            <v-btn small text :color="selectedFrame.id == frame.id ? 'primary' : 'default'" @click="selectedFrame = frame">{{ frame.frame_image }}</v-btn>
                        </template>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn @click="exportImage()" text><v-icon>mdi-download</v-icon> Export</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import { fabric } from 'fabric';
    import TestimonialDetailsDialog from './dialog/TestimonialDetailsDialog.vue';
    import QrCodeDialog from './dialog/QRCodeDialog.vue';
    export default {
        name : 'ApprovedTestimonialsListView',
        components : {
            TestimonialDetailsDialog,
            QrCodeDialog
        },
        data() {
            return {
                baseUrl : process.env.VUE_APP_BASE_URL,
                subscription : {},
                printDialog : false,
                details : {},
                post : {},
                post_dialog : false,
                qr_code_dialog : false,
                qr_code : null, 
                search : '',
                search1 : '',
                selectedImages : [],
                selectedFrame : {},
                resultImage : null,
                canvas: null,
                canvasOrientation : 'landscape',
                imagesRendered : false,
                headers : [
                    {
                        text : 'Name',
                        value : 'name',
                        sortable : true
                    },
                    {
                        text : 'Email',
                        value : 'email',
                        sortable : true
                    },
                    {
                        text : 'Mobile',
                        value : 'mobile_no',
                        sortable : true
                    },
                    {
                        text : 'Company',
                        value : 'company',
                        sortable : true
                    },
                    {
                        text : 'Position',
                        value : 'position',
                        sortable : true
                    },
                    {
                        text : 'Submitted',
                        value : 'submitted',
                        sortable : true
                    },
                    {
                        text : 'Visible',
                        value : 'visible',
                        sortable : true
                    },
                    {
                        text : 'Details',
                    },
                    {
                        text : 'QR Code',
                        value : 'qr_code',
                    }
                ],
                testimonials : []
            }
        },
        methods : {
            async refresh() {
                try {
                    let posts = await axios({
                        url : this.$store.state.api_url + '/subscriptions/' + this.$route.params.id + '/posts',
                        method : 'GET',
                        params : {approved : 1},
                        headers : {
                            Authorization : 'Bearer ' + this.$store.state.user.token
                        }
                    });
                    this.testimonials = posts.data;
                } catch (error) {
                    alert(error.message);
                }

                try {
                    let subscription = await axios({
                        url : this.$store.state.api_url + '/subscriptions/' + this.$route.params.id,
                        method : 'GET',
                        headers : {
                            Authorization : 'Bearer ' + this.$store.state.user.token
                        }
                    });

                    this.subscription = subscription.data;
                } catch (error) {
                    
                }
            },
            viewPostDetails(post) {
                this.post_dialog = true;
                this.post = post;
            },
            viewQRCode(qr_code) {
                this.qr_code_dialog = true;
                this.qr_code = qr_code;
            },
            getDetails() {
                axios({
                    url : this.$store.state.api_url + '/subscriptions/' + this.$route.params.id,
                    method : 'GET',
                    headers : {
                        Authorization : 'Bearer ' + this.$store.state.user.token
                    }
                }).then(res => {
                    this.details = res.data;
                });
            },
            exportRecords() {
                let csv = this.jsonToCSV(this.testimonials);
                this.downloadCSV(csv, this.details.event_code + '.csv');
            },
            jsonToCSV(data) {
                const headers = ['Name', 'Email', 'Mobile Number', 'Company', 'Position'];
                const rows = [];
                for (let d of data) {
                    rows.push([`"${d.name}"`, (d.email || ''), (d.mobile_no || ''), `"${d.company || ''}"`, `"${d.position || ''}"`].join(','));
                }

                return [headers, ...rows].join("\n");
            },
            downloadCSV(csv, filename = "posts.csv") {
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");

                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            },
            showPrintDialog() {
                this.printDialog = true;
            },
            selectImage(post) {
                this.initCanvas();
                let idx = this.selectedImages.indexOf(post.id);
                if(idx >=0 ) {
                    if(confirm("You are about to remove this image from your canvas.\Do you want to continue?")) {
                        this.removeImageFromCanvas(post.id);
                        this.selectedImages.splice(idx, 1);
                    }
                }
                else {
                    this.addImageToCanvas(post.id);
                    this.selectedImages.push(post.id);
                }
            },
            initCanvas() {
                if(!this.canvas) {
                    this.canvas = new fabric.Canvas(this.$refs.canvas, {
                        selection: false
                    });
                    this.canvas.preserveObjectStacking = true;
                }
            },
            async addImageToCanvas(id) {
                let imageUrl = await axios({
                    url : `${this.baseUrl}/api/proxy-image?post_id=${id}`,
                    method : 'GET'
                });

                // CONTENT IMAGE (draggable, resizable)
                fabric.Image.fromURL(
                    imageUrl.data.data,
                    img => {
                        const canvasHeight = this.canvas.getHeight();
                        if (img.height > canvasHeight) {
                            const scale = canvasHeight / img.height;
                            img.set({
                                left: 0,
                                top: 0,
                                scaleX: scale,
                                scaleY: scale,
                                selectable: true,
                                hasControls: true,
                                hasBorders: true
                            });
                        }
                        else {
                            img.set({
                                left: 0,
                                top: 0,
                                scaleX: 0.5,
                                scaleY: 0.5,
                                selectable: true,
                                hasControls: true,
                                hasBorders: true
                            });
                        }
                        img.id = id;
                        this.canvas.add(img);
                        this.canvas.setActiveObject(img);
                    },
                    { crossOrigin: 'anonymous' }
                );
            },
            removeImageFromCanvas(id) {
                const objects = this.canvas.getObjects();
                for(let o of objects) {
                    if(o.id == id) {
                        this.canvas.remove(o);
                        this.canvas.renderAll();
                        break;
                    }
                }
            },
            exportImage() {
                 // Export canvas as PNG data URL
                const dataURL = this.canvas.toDataURL({
                    format: 'png',
                    multiplier : 2
                });

                // Create a temporary <a> element to trigger download
                const link = document.createElement('a');
                link.href = dataURL;
                link.download = this.details.event_code?.substring(0, 8) + '.png';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            async addFrame() {
                this.initCanvas();
                let frameUrl = await axios({
                    url : `${this.baseUrl}/api/proxy-image?frame_id=${this.selectedFrame.id}`,
                    method : 'GET'
                });
                // FRAME IMAGE (locked on top)
                fabric.Image.fromURL(
                    frameUrl.data.data,
                    img => {
                        let canvasHeight = this.canvas.getHeight();
                        const scale = canvasHeight / img.height;
                        img.set({
                            left: 0,
                            top: 0,
                            scaleX: scale,
                            scaleY: scale,
                            selectable: true,
                            lockMovementX: true,
                            lockMovementY: true,
                            lockScalingX: true,
                            lockScalingY: true,
                            lockRotation: true,
                            hasControls: true,
                            hasBorders: true
                        });
                        img.id = 'frame';
                        img.scaleToWidth(this.canvas.width);
                        img.scaleToHeight(this.canvas.height);

                        this.canvas.add(img);
                    },
                    { crossOrigin: 'anonymous' }
                );
            },
            removeSelected() {
                const active = this.canvas.getActiveObject();
                if (!active) return;

                this.canvas.remove(active);
                if(active.id == 'frame') {
                    this.selectedFrame = {};
                }
                else {
                    this.selectedImages.splice(this.selectedImages.indexOf(active.id), 1);
                }
                
            },
            bringToFront() {
                const active = this.canvas.getActiveObject();
                this.canvas.bringToFront(active);
                this.canvas.requestRenderAll();
            },
            sendToBack() {
                const active = this.canvas.getActiveObject();
                console.log(active);
                this.canvas.sendToBack(active);
                this.canvas.requestRenderAll();
            },
            setCanvasOrientation(orientation) {
                this.initCanvas();
                this.canvasOrientation = orientation;
            },
            onKeydown(e) {
                console.log(e);
                if (e.key === "Delete" || e.key === "Backspace") {
                    this.removeSelected();
                }
            },
            async generateImage() {
                if(this.selectedImages.length == 0) {
                    return;
                }

                for(let i of this.selectedImages) {
                    let imageUrl = await axios({
                        url : `${this.baseUrl}/api/proxy-image?post_id=${i}`,
                        method : 'GET'
                    });

                    // CONTENT IMAGE (draggable, resizable)
                    fabric.Image.fromURL(
                        imageUrl.data.data,
                        img => {
                        img.set({
                            left: 0,
                            top: 0,
                            scaleX: 0.5,
                            scaleY: 0.5,
                            selectable: true,
                            hasControls: true,
                            hasBorders: true
                        });
                        img.id = i;
                        this.canvas.add(img);
                        this.canvas.setActiveObject(img);
                        },
                        { crossOrigin: 'anonymous' }
                    );
                }
            }
        },
        mounted() {
            this.getDetails();
            this.refresh();
        },
        computed : {
            filteredPosts() {
                if(this.search) {
                    return this.testimonials.filter(t => t.name?.toLowerCase().includes(this.search))
                }
                else {
                    return this.testimonials;
                }
            }
        },
        watch : {
            // selectedImages(newVal, oldVal) {
            //     if(oldVal) {
            //         this.generateImage();
            //     }
            // },
            selectedFrame(newVal, oldVal) {
                if(oldVal) {
                    if(newVal?.id) {
                        this.addFrame();
                    }
                }
            },
            canvasOrientation(newVal, oldVal) {
                if(oldVal) {
                    if(newVal == 'portrait') {
                        this.canvas.setDimensions({
                            width: 500,
                            height: 750
                        });
                    }
                    else if(newVal == 'landscape') {
                        this.canvas.setDimensions({
                            width: 750,
                            height: 500
                        });
                    }
                }
                console.log(newVal)
            }
        }
    }
</script>
<style scoped>
    .image {
        opacity: 0.5;
        background: black;
    }
    .image.selected {
        opacity: 1;
        border: 1px solid red;
    }
</style>